exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.configurations .tab-content {\n  background: #f7f7f7;\n}\n.configurations .nav-tabs .nav-link.active {\n  color: black !important;\n  border-radius: 5px 5px 0 0;\n  border-bottom-color: #f7f7f7;\n  background: linear-gradient(to top, #f7f7f7 90%, #737373 91%) !important;\n}\n.configurations .nav-tabs .nav-link {\n  color: #737373;\n}\n.configurations .nav-link.disabled {\n  cursor: not-allowed;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-85218802","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/settings/configurations.vue
// module id = 1309
// module chunks = 2